export const allCompanyTypes = new Map();
allCompanyTypes.set('businessAssociation', false);
allCompanyTypes.set('centerId', false);
allCompanyTypes.set('entityManagementBusinessArea', false);
allCompanyTypes.set('europeanCenter', false);
allCompanyTypes.set('ong', false);
allCompanyTypes.set('prefersConsortiums', false);
allCompanyTypes.set('startUpCompany', false);
allCompanyTypes.set('technologyInstitutes', false);
allCompanyTypes.set('tractingCompany', false);